
import { Folder, FolderType } from "@/types/folder"
import { Component, Prop, Vue } from "vue-property-decorator"

import FolderSetup from "@/components/Config/Folders/FolderSetup.vue"
import { Team } from "@/types"
import { Getter } from "vuex-class"
import { TenantFeatures } from "@/types/tenantFeatures"
import api from "@/services/api"
import SkeletonLoader from "@/components/SkeletonLoader.vue"

@Component({
	components: {
		"folder-setup": FolderSetup,
		"skeleton": SkeletonLoader
	}
})
export default class SourceSettings extends Vue {
	@Getter
	getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	FolderType = FolderType
	teams: Team[] = []
	folders: Folder[] = []

	private isLoadingOnMount = false
	private isLoadingMisc = false

	private get isLoading (): boolean {
		return this.isLoadingOnMount || this.isLoadingMisc
	}

	async mounted () {
		this.isLoadingOnMount = true
		const loadTeamsPromise = api.teamsGet()
		const refreshFoldersPromise = this.refreshFolders()
		await Promise.allSettled([loadTeamsPromise, refreshFoldersPromise])
		this.teams = await loadTeamsPromise
		this.isLoadingOnMount = false
	}

	async refreshFolders (): Promise<void> {
		this.folders = await api.foldersGet(FolderType.DataSource)
	}

	get dataSourceFoldersFeatureIsEnabled (): boolean {
		return this.getIsFeatureEnabled(TenantFeatures.DataSourceFolders)
	}

	folderDeleted () {
		this.$emit("refresh-source-folders")
		this.$emit("refresh-sources")
	}
}

